import { Drawer } from "antd";
import styled from "styled-components";

export const DrawerContainer = styled(Drawer)`
  .drawerForm {
    width: 100%;
    padding: 0px 24px;
    padding-bottom: 20px;
    min-height: -moz-calc(100vh - 165px);
    min-height: -webkit-calc(100vh - 165px);
    min-height: calc(100vh - 165px);
  }

  .rowLabel {
    margin: 8px 0px;
  }

  label {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;
    &.error {
      color: #d44c4c;
      margin-left: 15px;
    }
  }

  .ant-select {
    width: 100%;
  }
`;
